import { defineMessages } from 'react-intl';

export const messages: {
	addTranslation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	back: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	defaultLanguageDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	defaultLanguageIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	languageFieldLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loadingLanguages: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noFields: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	panelTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	removeTranslation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	selectLanguage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	addTranslation: {
		id: 'company-hub-common.config-panel.manage-translations.addTranslation.non-final',
		defaultMessage: 'Add translation',
		description: 'Button text for adding a new locale translation.',
	},
	back: {
		id: 'company-hub-common.config-panel.manage-translations.back.non-final',
		defaultMessage: 'Back',
		description: 'Accessible label for returning from the translations view.',
	},
	description: {
		id: 'company-hub-common.config-panel.manage-translations.description',
		defaultMessage: 'Manage and update your translations here.',
		description: 'Help text shown above the translations view.',
	},
	loadingLanguages: {
		id: 'company-hub-common.config-panel.manage-translations.loadingLanguages.non-final',
		defaultMessage: 'Loading available languages',
		description: 'Accessible label for the spinner shown while translation languages are loading.',
	},
	defaultLanguageDescription: {
		id: 'company-hub-common.config-panel.manage-translations.defaultLanguageDescription.non-final',
		defaultMessage: 'Your default language is {defaultLanguage}.',
		description: 'Descriptive text shown below the default locale row in the translations panel.',
	},
	defaultLanguageIconLabel: {
		id: 'company-hub-common.config-panel.manage-translations.defaultLanguageIconLabel.non-final',
		defaultMessage: 'Default language',
		description: 'Accessible label for the icon shown beside the default language.',
	},
	emptyStateHeader: {
		id: 'company-hub-common.config-panel.manage-translations.emptyStateHeader.non-final',
		defaultMessage: 'No translations yet',
		description: 'Header text for the empty state shown when no translations have been added.',
	},
	emptyStateDescription: {
		id: 'company-hub-common.config-panel.manage-translations.emptyStateDescription.non-final',
		defaultMessage: 'Convey your help center content in multiple languages',
		description: 'Description text for the empty state shown when no translations have been added.',
	},
	languageFieldLabel: {
		id: 'company-hub-common.config-panel.manage-translations.languageFieldLabel.non-final',
		defaultMessage: 'Language',
		description: 'Label for a translation language select field.',
	},
	noFields: {
		id: 'company-hub-common.config-panel.manage-translations.noFields.non-final',
		defaultMessage: 'This extension does not expose any translatable fields.',
		description: 'Text shown when the extension has no translatable fields.',
	},
	panelTitle: {
		id: 'company-hub-common.config-panel.manage-translations.panelTitle.non-final',
		defaultMessage: 'Translations',
		description: 'Panel title shown when the translations view is open.',
	},
	removeTranslation: {
		id: 'company-hub-common.config-panel.manage-translations.removeTranslation.non-final',
		defaultMessage: 'Remove translation',
		description: 'Button text for removing a locale translation.',
	},
	selectLanguage: {
		id: 'company-hub-common.config-panel.manage-translations.selectLanguage.non-final',
		defaultMessage: 'Select language',
		description: 'Section heading shown above the language picker.',
	},
	title: {
		id: 'company-hub-common.config-panel.manage-translations.title.non-final',
		defaultMessage: 'Manage translations',
		description: 'Legacy section title for the shared manage translations form.',
	},
});
